<div class="vi-item">
  <div class="vi-label">
    <h4>{{ label }}</h4>
  </div>
  <div class="vi-value">
    <h4>{{ value }}</h4>
  </div>
</div>
